import reportItems from "assets/js/widgetItems";
import { styled } from "@mui/system";
import shortid from "shortid";
import { Button, Typography } from "@mui/material";
import { memo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { appCloseModal, appSetSettings, appSetWidget } from "store/actions/appAction";
import { apiGetAppSettings, apiSetAppSettings } from "api/appApi";

const WidgetItemContainer = styled("div")(
  ({ theme, selected }: { theme?: ThemeObjType; selected?: any }) => ({
    height: "180px",
    marginBottom: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    boxShadow: selected ? "0px 0px 10px 0px #dbdbdb" : "none",
    borderRadius: theme?.shape.borderRadius,
    border: `3px solid ${theme?.palette.disabled.light}`,
  })
);
const WidgetImageContainer = styled("div")(({ theme }) => ({
  flex: 2,
  width: "100%",
  padding: "10px",
}));
const WidgetText = styled(Typography)(({ theme }) => ({
  flex: 1,
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
const WidgetImage = styled("img")(({ theme }) => ({
  flex: 1,
  width: "100%",
  height: "auto",
}));
const GridBox = styled("div")(({ theme }) => ({
  maxHeight: "550px",
  overflowY: "auto",
  overflowX: "hidden",
  display: "grid",
  padding: "15px",
  gridTemplateColumns: " repeat(auto-fill, 23%)",
  gridGap: "1% 2%",
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "repeat(auto-fill, 32%)",
    gridGap: "2% 2%",
  },
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(auto-fill, 44%)",
    gridGap: "2% 3%",
  },
  justifyContent: "space-between",
}));

const BottomSection = styled("div")({
  height: "66px",
  display: "flex",
  justifyContent: "space-between",
  padding: "15px",
});
const RightButtonContainer = styled("div")({
  width: "250px",
  display: "flex",
  justifyContent: "space-between",
});

const StyledButton = styled(Button)({
  padding: "0px 20px 0 20px",
  "&:hover": {
    backgroundColor: "none",
  },
});

const AddWidgetModal = memo(() => {
  // @ts-ignore
  const { widgets } = useSelector((state) => state).appReducer as { widgets: Partial<typeof reportItems> };
  //@ts-ignore
  const appSettings = useSelector((state) => state).appReducer?.appSettings || [];

  const [selected, setSelected] = useState<Partial<typeof reportItems>>(widgets);

  const dispatch = useDispatch();

  const handleSelection = (key: number) => {
    // @ts-ignore
    selected[key] = selected[key] ? null : reportItems[key];
    setSelected([...selected]);
  };

  const determineAddIsDisabled = () => {
    if (selected) {
      const index = selected.findIndex((object) => object !== null);
      if (index === -1) return true;
    }
    return false;
  };
  const determineClearAllIsDisabled = () => {
    if (selected) {
      const index = selected.findIndex((object) => object !== null);
      if (index === -1) return true;
    }
    return false;
  };
  const determineChooseAllDisabled = () => {
    if (selected) {
      const filtered = selected.filter((object) => object === null);
      if (filtered.length === 0) return true;
    }
    return false;
  };

  const clearAllSelected = () => {
    return setSelected(Array(reportItems.length).fill(null));
  };
  const chooseAll = () => {
    return setSelected([...reportItems]);
  };

  const onChange = (key: any, value: any) => {
    let temp = {
      ...appSettings,
      [key]: value,
    };
    return temp;
  };

  const token = useSelector((state: any) => state).businessReducer?.business?.token;

  const submitData = async (data: any, token: string, dispatch: any) => {
    // const token = useSelector((state: any) => state).businessReducer?.business?.token;
    try {
      await apiSetAppSettings({ token: token, settings: data }).then((response) => {
        initialData(dispatch, token);
      });
    } catch (error) {} finally {}
  };

  const initialData = async (dispatch: (arg0: { type: string; value: any }) => void, token: string) => {
    // const dispatch = useDispatch();
    // const token = useSelector((state: any) => state).businessReducer?.business?.token;
    try {
      await apiGetAppSettings({ token: token }).then((response) => {
        dispatch(appSetSettings(response?.data.settings));
      });
    } catch (error) {}
  };

  return (
    <>
      <GridBox>
        {reportItems.map((item, key) => (
          <WidgetItemContainer
            selected={selected ? selected[key] : false}
            onClick={() => handleSelection(key)}
            key={shortid.generate()}
          >
            <WidgetImageContainer>
              <WidgetImage src={item.imagePath} />
            </WidgetImageContainer>
            <WidgetText
              fontWeight={selected && selected[key] ? "bold" : "normal"}
              variant="caption"
              textAlign="center"
            >
              {item.title}
            </WidgetText>
          </WidgetItemContainer>
        ))}
      </GridBox>
      <BottomSection>
        <RightButtonContainer>
          <StyledButton
            sx={{ padding: 0, width: "100px" }}
            onClick={() => chooseAll()}
            disabled={determineChooseAllDisabled()}
            color="disabled"
            variant="outlined"
          >
            انتخاب همه
          </StyledButton>
          <StyledButton
            sx={{ padding: 0, width: "100px" }}
            onClick={() => clearAllSelected()}
            disabled={determineClearAllIsDisabled()}
            color="disabled"
          >
            پاک کردن
          </StyledButton>
        </RightButtonContainer>
        <StyledButton
          onClick={() => {
            const temp = onChange("widgets", JSON.stringify(selected));
            submitData(temp, token, dispatch);
            dispatch(appSetWidget(selected));
            dispatch(appCloseModal());
          }}
          //  disabled={determineAddIsDisabled()}
          variant="contained"
        >
          ذخیره
        </StyledButton>
      </BottomSection>
    </>
  );
});

export default AddWidgetModal;
